import { cn } from '@/shared/lib/cn';
import styles from './RollingNumber.module.css';

export interface RollingNumberProps {
  value: number;
  className?: string;
}

const Digit: React.FC<{ d: string }> = ({ d }) => {
  const n = Number(d);
  if (Number.isNaN(n)) return <span className={styles.sep}>{d}</span>;
  return (
    <span className={styles.digit}>
      <span className={styles.col} style={{ transform: `translateY(-${n}em)` }}>
        {Array.from({ length: 10 }, (_, i) => (
          <span key={i} className={styles.cell}>
            {i}
          </span>
        ))}
      </span>
    </span>
  );
};

/**
 * @use число, которое меняется на глазах: цифры прокручиваются вместо скачка.
 */
export const RollingNumber: React.FC<RollingNumberProps> = ({ value, className }) => {
  const digits = String(Math.max(0, Math.trunc(value || 0)));
  return (
    <span className={cn(styles.row, className)} aria-label={String(value)}>
      {digits.split('').map((d, i) => (
        <Digit key={`${digits.length}-${i}`} d={d} />
      ))}
    </span>
  );
};
